import { combineReducers } from 'redux';
import { modals } from 'controls/modals/reducer';
import { siteInfoInfoReducer } from './siteInfo';
import { userInfoReducer } from './userInfo';
import { ordersReducer } from './orders';
import { entitlementReducer } from './entitlements';
import { subscriptionReducer } from './subscriptions';
import { fetchStatusReducer } from './fetchStatus';

export const rootReducer = combineReducers({
  modals,
  siteInfo: siteInfoInfoReducer,
  userInfo: userInfoReducer,
  orders: ordersReducer,
  entitlement: entitlementReducer,
  subscription: subscriptionReducer,
  fetchStatus: fetchStatusReducer,
});
